var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.warningModal},[_c('a-input',{class:_vm.$style.textarea,attrs:{"placeholder":"请输入标题名称"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }